import React from "react";

export default function Newspaper(props: any) {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5 3C0.5 1.89543 1.39543 1 2.5 1H9.5C10.6046 1 11.5 1.89543 11.5 3V8.875C11.5 9.97957 10.6046 10.875 9.5 10.875H2.5C1.39543 10.875 0.5 9.97957 0.5 8.875V3Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M2 3.75C2 3.19772 2.44772 2.75 3 2.75H5C5.55228 2.75 6 3.19772 6 3.75V4.5C6 5.05228 5.55228 5.5 5 5.5H3C2.44772 5.5 2 5.05228 2 4.5V3.75Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 3.125L7.5 3.125" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 5.125L7.5 5.125" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 7.125L2 7.125" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 9.125L2 9.125" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
}
